<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditInstitutions()"
	[showDeleteButton]="canDeleteInstitutions()"
	(editClicked)="openEdit()"
	(deleteClicked)="openDialog()"
	[disableEditButton]="workplace().isMainInstitution"
	[disableDeleteButton]="workplace().isMainInstitution"
	[disableEditTranslationKey]="'workplace.details.edit_disabled'"
	[disableDeleteTranslationKey]="'workplace.details.delete_disabled'"
>
	{{ workplace().name }}
</lvr-heading>
<section class="grid" role="region">
	<table>
		<!-- Name / Street address -->
		<tr>
			<th scope="col">{{ 'workplace.details.name' | transloco }}</th>
			<th scope="col">{{ 'workplace.details.street_address' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ workplace().name }}</td>
			<td>{{ workplace().address?.streetAndHouseNumber }}</td>
		</tr>

		<!-- Remark / Postal code and city -->
		<tr>
			<th scope="col">{{ 'workplace.details.remark' | transloco }}</th>
			<th scope="col">{{ 'workplace.details.postal_code_and_city' | transloco }}</th>
		</tr>
		<tr>
			<td>
				{{ workplace().address?.identifier || '-' }}
				@if (user().roles?.id === eaaRole && workplace().industryName) {
					<p>{{ workplace().industryName }}</p>
				}
			</td>
			<td>{{ workplace().address?.postalCodeAndCity }}</td>
		</tr>

		<!-- School number -->
		@if (isSchool()) {
			<tr>
				<th scope="col" colspan="2">{{ 'institution.details.school_number' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ schoolNumber() || '-' }}</td>
			</tr>
		}

		<!-- Responsible persons / Preferred communication -->
		<tr>
			@if (responsibleInstitutionPersons().length === 1) {
				<th scope="col">{{ 'workplace.details.responsilbe_person' | transloco }}</th>
			} @else {
				<th scope="col">{{ 'workplace.details.responsible_persons' | transloco }}</th>
			}
			<th scope="col">{{ 'workplace.details.preferred_communication' | transloco }}</th>
		</tr>
		<tr>
			<td>
				<ul>
					@for (responsiblePerson of responsibleInstitutionPersons(); track responsiblePerson.id) {
						<li>
							<a [routerLink]="['/desk/institution', institution().id, 'persons', responsiblePerson.id]">
								{{
									responsiblePerson.firstName
										? responsiblePerson.name + ', ' + responsiblePerson.firstName
										: responsiblePerson.name
								}}
							</a>
						</li>
					}
				</ul>
			</td>
			<td>
				<ul>
					@for (cp of preferredCommunicationPoints(); track cp.id) {
						<li>
							@if (cp.categoryContactPointId === types.phone) {
								<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
							} @else if (cp.categoryContactPointId === types.email) {
								<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
							} @else {
								<span>{{ cp.contactValue }}</span>
							}
							<p>{{ cp.remark }}</p>
						</li>
					}
				</ul>
			</td>
		</tr>

		<!-- - / Other communication -->
		<tr>
			<th scope="col"></th>
			<th scope="col">{{ 'workplace.details.other_communication' | transloco }}</th>
		</tr>
		<tr>
			<td></td>
			<td>
				<ul>
					@for (cp of otherCommunicationPoints(); track cp.id) {
						<li>
							@if (cp.categoryContactPointId === types.phone) {
								<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
							} @else if (cp.categoryContactPointId === types.email) {
								<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
							} @else {
								<span>{{ cp.contactValue }}</span>
							}
							<p>{{ cp.remark }}</p>
						</li>
					}
				</ul>
			</td>
		</tr>
	</table>
</section>
<lvr-institution-activity [institutionId]="institution().id" [branchId]="workplace().id"></lvr-institution-activity>
